module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Paris detention center, Porte des Lilas, 1945")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y THE TIME THE")]), _vm._v(" three military policemen delivered him to the gaol it was after midnight and he had a closed eye, a split lip and a football-sized knee from a truncheon blow. They had to drag him up the worn stone steps to the guardroom on the third floor, the political section, where he was forced to strip out of his US Army uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It might have been spring outside, but it had failed to penetrate the ancient walls of the fort that served as the Allies’ detention centre and he was soon shivering. He had enough sense, though, not to try to hide his nakedness. He had been in this state before, and any attempt to cover his genitals or to assume a defensive posture was like blood in the water to sharks. The Redcaps were itching to use their truncheons again. He had to minimise the risk of that happening.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The guards took their time completing the transfer paperwork and as his teeth started to chatter he shuffled a few steps towards the ancient pot-bellied stove in the corner, but one of his captors slapped him back into place with an open hand. He could taste blood now.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His arrest detail finally departed with a farewell poke in the ribs, and he was left in the charge of the Paris Detention Centre guards, one Englishman and an American. They threw him a set of blue coveralls and thin, grey underwear and he dressed as quickly as his damaged knee would allow.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What’s with the American uniform?’ asked the Yank as he picked up the discarded jacket and binned it. ‘You ain’t one of us.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Seconded,’ he said through his clashing teeth. ‘From the British army.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The American looked down at the charge sheet and ran his finger along the list. ‘So how come it says under item fifteen: impersonating an American officer?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Misunderstanding.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yeah. Hey, you hear what the sentence for that Guy William Joyce was today? Your Lord Haw Haw?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Strictly speaking, I think he’s yours,’ the prisoner said. The famous traitor was American born, although since he had taken UK citizenship, the British had decided they should have the privilege of punishing him. ‘But I can guess.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The American sniggered. ‘I think you’ll be doing better than that, pal. I think you’ll be following his footsteps up that scaffold.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He didn’t like the Yank, and was relieved when the Englishman indicated he should accompany him down the corridor to the cell. The guard unlocked a cupboard on the wall and took out a Colt sidearm along with an almost medieval key.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Nasty eye,’ he said as they left the guardroom.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s worse from the inside.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘And the leg?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s going to be an interesting colour tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Fell downstairs, did you?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I suppose I did.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘We get a lot of that.’ The guard stopped before cell eight, turned the heavy key and pushed the battered steel door open.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Can I see a doctor?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You’ll live till morning,’ the man replied. ‘In you go, Mason.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He limped inside and lowered himself gingerly onto the bed. It had been a long night, and one that had started so promisingly. Women, he thought bitterly, they really will be the death of me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I suppose you want a cuppa?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yeah,’ he said, modulating his cockney accent to mimic his gaoler’s. ‘I could murder a cup of tea.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The guard laughed. ‘I’d watch what you say, mate. You’re in enough trouble as it is. That’s the longest bloody charge sheet I have ever seen.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As the Englishman turned to leave, the prisoner asked quickly: ‘I don’t suppose there is any chance of a typewriter, is there?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘A typewriter? At this time of night? You’ll wake up half the block.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No. For tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I doubt it, mate. What’s it for? An appeal?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He hadn’t even had a trial yet, but he knew everyone thought the verdict a mere formality. ‘Something like that.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’ll see,’ the man said grudgingly, then hesitated. ‘Is it all true, Mason?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Is what all true?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What they said about you on the detention order and the charge sheet? What you did?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The prisoner smiled grimly as he thought about the charges, a seven-year fairground ride around Europe reduced to nineteen stark indictments. Was it all true? Well, he couldn’t deny the bare facts. His salvation would be in the details, if he could make anyone listen. ‘Pretty much,’ he finally said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Englishman nodded and said quietly: ‘In which case, you can shove the typewriter up yer arse.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c454a08c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5chap1.vue
// module id = 72
// module chunks = 0